module.exports = __webpack_public_path__ + "414a34e6a03a9574249b3bc967fef21d.svg";